<template>
	<div>
		<v-dialog v-model="value" persistent max-width="600px" scrollable>
			<v-card>
				<v-card-title class="headline gradiente lighten-2 elevation-3">
					<span class="white--text">{{ title }}</span>
				</v-card-title>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex order-xs2 order-md2 xs12 md6>
								<v-layout wrap>
									<v-flex xs12>
										<v-text-field
											:error-messages="nameErrors"
											v-model="userForm.firstName"
											label="Nombre(s)"
											required
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											:error-messages="lastNameErrors"
											v-model="userForm.lastName"
											label="Apellidos"
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
								<v-layout
									align-center
									justify-center
									row
									fill-height
									wrap
									v-on:mouseover="flags.updateImage = true"
									v-on:mouseleave="flags.updateImage = false"
								>
									<v-flex style="text-align: center;" sm7 v-show="working.wImage">
										<v-progress-circular indeterminate color="primary"></v-progress-circular>
									</v-flex>
									<v-flex
										v-show="!working.wImage"
										xs7
										style="border-radius: 50%;"
										id="parentContainerEmployeeImage"
										class="gradiente"
									>
										<label id="img_edit_employee_default">
											<v-img :src="require('@/assets/panel/modals/AddPhotoIcon@3x.png')"></v-img>
										</label>
										<label style="display: none; text-align: center;" id="img_edit_employee"></label>

										<!-- <input
											type="file"
											id="edit_logo"
											name="edit_logo"
											accept="image/*"
											style="display: none;"
											@change="processImage($event)"
										>-->
									</v-flex>
									<br />
									<v-flex xs7>
										<v-expand-transition>
											<v-btn
												block
												class="gradiente"
												style="border-radius: 33px;"
												v-show="flags.updateImage"
												dark
												@click="modals.image = true"
											>Actualizar</v-btn>
										</v-expand-transition>

									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						
		<loading v-model="working.wUpdate" text="Trabajando..."></loading>
		<success v-if="familiar !== null" v-model="toast.success" text="Creación Exitosa"></success>
		<success v-else v-model="toast.success" text="Actualización Exitosa"></success>
		<error v-model="toast.failed" text="Ups ocurrió un error"></error>		
		<error v-model="toast.image" :text="text.image"></error>
		<editImage v-on:loaded="processImage($event)" v-model="modals.image"></editImage>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn :disabled="working.wUpdate" flat @click="close">Cancelar</v-btn>
					<v-btn :disabled="working.wUpdate" color="primary darken-1" flat @click="submit">Guardar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import { required } from "vuelidate/lib/validators";
	import { funciones } from "../../Mixins/Funciones.js";
	import loading from "../Dialogs/Loading.vue";
	import success from "../Dialogs/Success.vue";
	import error from "../Dialogs/Error.vue";
	import editImage from "../Modals/EditImage";
	import { setTimeout } from "timers";
	export default {
		props: ["title", "parentId",  "value"],
		components: {
			loading,
			success,
			error,
			editImage
		},
		validations: {
			userForm: {
				firstName: { required },
				lastName: { required }
			}
		},
		watch: {
			value() {
				if (this.value) {
					if (this.familiar != null) {
						this.userForm.id = this.familiar.id;
						this.userForm.firstName = this.familiar.firstName;
						this.userForm.lastName = this.familiar.lastName;
						if (this.familiar.famFoto != null && this.familiar.famFoto != "") {
							this.processImage(this.familiar.famFoto);
						}
						
					}
				}
			}
		},
		mounted() {},
		data: () => ({
			modals: {
				image: false
			},
			userForm: {
				
            },
            familiar : null,
			userImg: null,
			working: {
				wUpdate: false,
				wImage: false
			},
			toast: {
				success: false,
				failed: false,
				image: false
			},
			flags: {
				updateImage: false
			},
			text : {
				image : ""
			}
		}),
		methods: {
			processImage(event) {
				this.working.wImage = true;
				this.userForm.image = event.split(",")[1];
				document.getElementById(
					"img_edit_employee"
				).innerHTML = `<img class="elevation-4" src="${event}" style='width: 120px; height: 120px; object-fit: cover; border-radius: 50%;'>`;
				document.getElementById("img_edit_employee").style.display = "block";
				document
					.getElementById("parentContainerEmployeeImage")
					.classList.remove("gradiente");
				document.getElementById("img_edit_employee_default").style.display =
					"none";
				this.working.wImage = false;
			},
			submit() {
				this.$v.userForm.$touch();
				if (!this.$v.userForm.$invalid) {
					if(this.userForm.image){
						this.working.wUpdate = true;
						if (this.familiar == null) {
													this.userForm.id = this.parentId;
							var obj = this.userForm;
							this.$store
								.dispatch("tutor/generateFamiliarQr", obj)
								.then(response => {
									this.working.wUpdate = false;
									this.toast.success = true;
									this.$emit("created", response.data.entity);
									this.close();
								})
								.catch(error => {
									this.working.wUpdate = false;
									this.toast.failed = true;
									console.log(error);
								});
						}
					}else{				
						this.toast.image = true;
						this.text.image = "Imagen requerida";
						console.log("Image not charged");
					}
				}
			},
			close() {
				this.$v.$reset();
				document.getElementById("img_edit_employee").innerHTML = ``;
				document.getElementById("img_edit_employee").style.display = "none";
				document
					.getElementById("parentContainerEmployeeImage")
					.classList.add("gradiente");
				document.getElementById("img_edit_employee_default").style.display =
					"block";
				this.userForm = {};
				this.$emit("input", !this.value);
			}
		},
		computed: {
			lastNameErrors() {
				const errors = [];
				if (!this.$v.userForm.lastName.$dirty) return errors;
				!this.$v.userForm.lastName.required &&
					errors.push("Apellidos obligatorios");

				return errors;
			},
			nameErrors() {
				const errors = [];
				if (!this.$v.userForm.firstName.$dirty) return errors;
				!this.$v.userForm.firstName.required && errors.push("Nombre obligatorio");
				return errors;
			}
		}
	};
</script>

<style>
</style>
